import { render, staticRenderFns } from "./KontrolGecmisi.vue?vue&type=template&id=11494ed2&"
import script from "./KontrolGecmisi.vue?vue&type=script&lang=js&"
export * from "./KontrolGecmisi.vue?vue&type=script&lang=js&"
import style0 from "./KontrolGecmisi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports